import React, { FC, useEffect, useState } from 'react';
import { FormControl, FormHelperText, InputLabel, Select } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';
import { AppointmentType } from '../../interfaces/api/Collaborative';
import useCollaborative from '../../hooks/api/useCollaborative';

interface Props {
  value?: string;
  error?: boolean;
  helperText?: string;
  className?: any;
  fullWidth?: boolean;
  onChange: (event: React.ChangeEvent<{ name?: string; value: unknown }>) => void;
}

const AppointmentTypeSelect: FC<Props> = React.forwardRef<any, Props>(
  ({ onChange, className, value, helperText, ...props }, ref) => {
    const [appointmentTypes, setAppointmentTypes] = useState<AppointmentType[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>();

    const { getAppointmentTypes } = useCollaborative();

    useEffect(() => {
      getAppointmentTypes()
        .then((collection) => {
          setAppointmentTypes(collection.items);
          setLoading(false);
        })
        .catch((e) => {
          setError(e.message);
          setLoading(false);
        });
    }, []);

    if (loading) {
      return <Skeleton height={50} />;
    }

    if (error) {
      return <div style={{ color: '#f44336' }}>{error}</div>;
    }

    return (
      <FormControl ref={ref} className={className} variant='outlined' error={props.error} {...props}>
        <InputLabel>Type de RDV</InputLabel>
        <Select native value={value} onChange={onChange} label='Type de RDV'>
          <option value='' />
          {appointmentTypes.map((appointmentType, key) => (
            <option key={key} value={appointmentType.id}>
              {appointmentType.name}
            </option>
          ))}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  }
);

export default React.memo(AppointmentTypeSelect);
